import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-change-password-popup',
  templateUrl: './change-password-popup.component.html',
  styleUrls: ['./change-password-popup.component.css']
})
export class ChangePasswordPopupComponent implements OnInit {
  public username;
  public password;
  public confirmPassword;
  public passwordMatchBool;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  public dialogRef: MatDialogRef<ChangePasswordPopupComponent>) { }

  ngOnInit() {
  }

  passwordMatch() {
    if (this.password === this.confirmPassword) {
      this.passwordMatchBool = false;
    } else {
      this.passwordMatchBool = true;
    }
  }

  cancel() {
    this.dialogRef.close('Cancel');
  }

  proceed() {
    this.dialogRef.close({
      'username': this.username,
      'password': this.password
    });
  }

}
